import { useEffect, useState } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';
import * as Types from 'helpers/types';
import { useDispatch } from 'react-redux';

export default () => {
  const dispatch = useDispatch();
  const [addresses, setAddresses] = useState([]);
  const [registeredAddress, setRegisteredAddress] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const getAddresses = async () => {
      try {
        const response = await pharmacy.get(`/patients/address`);
        setAddresses(response.data);
        setRegisteredAddress(response.data.find((a) => a?.name === 'GP Registered'));
        dispatch({ type: Types.ADDRESSES_SUCCESS, payload: response.data });
        setLoading(false);
      } catch (e) {
        setLoading(false);
        history.push('/pharmacy/error');
      }
    };

    getAddresses();
  }, [history]);

  return [addresses, loading, registeredAddress];
};
